import { StorageKeyEnum } from '@constant';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILoginResponse, IStoreAuth } from '@types';

const initialState: IStoreAuth = {
  isLogin: false,
  name: '',
  email: ''
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<ILoginResponse>) => {
      localStorage.removeItem(StorageKeyEnum.LEGACY_META_TAG_LIST_DATA_KEY); //TODO: 레거시 localStorage 제거용 코드. 16차 스프린트 작업시 제거
      localStorage.removeItem(StorageKeyEnum.LEGACY_COMIC_NAME_LIST_DATA_KEY); //TODO: 레거시 localStorage 제거용 코드. 16차 스프린트 작업시 제거

      sessionStorage.setItem('accessToken', action.payload.token.accessToken);
      sessionStorage.setItem('refreshToken', action.payload.token.refreshToken);

      return { isLogin: true, name: action.payload.user.name, email: action.payload.user.email };
    },

    logout: () => {
      sessionStorage.clear();
      return initialState;
    }
  }
});

export const { login, logout } = authSlice.actions;

export default authSlice.reducer;
